module.exports = __webpack_public_path__ + "img/8.552b1cc0.jpg";